import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalHead } from '@dixa/lib-shared-habla';
import { InstrumentPanelTitle } from '../../../panel/components/title/instrumentPanelTitle';
import { InstrumentComparison } from '../../instrumentComparison';
import styles from './instrumentComparisonModal.module.scss';
export const InstrumentComparisonModal = ({ panel, onClose, }) => {
    return (_jsxs(Modal, Object.assign({ className: styles.modal, isOpen: true, onClose: onClose }, { children: [_jsx(ModalHead, { title: _jsx("div", Object.assign({ "data-analytics-panel": panel.id }, { children: _jsx(InstrumentPanelTitle, { panel: panel }) })), onClose: onClose }), _jsx(ModalBody, { children: _jsx(InstrumentComparison, { panel: panel }) })] })));
};
